import { useEffect, useRef, useState } from "react";

import Calculator from "../../components/ui/Calculator"; // update path as needed

import { SettingsIcon } from "lucide-react";
import CompanyForm from "./CompanyForm";
import UsersTable from "./UsersTable";
import AddUser from "./AddUser";
import { AdminUser } from "../../models/AdminUser";
import { getEmptyAddUser } from "../../utils/user-utils";
import AcUserRequestTable from "./AcUserRequestTable";

const CompanyProfile = () => {
  const [showCalculator, setShowCalculator] = useState(false);
  const [selectedTab, setSelectedTab] = useState<any>(1);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [userData, setUserData] = useState<AdminUser>(getEmptyAddUser());
  const userTableRef: any = useRef(null);

  const addEditModel = (data?: any) => {
    setUserData(data);
    setUserModalOpen(true);
  };

  const closeModal = () => {
    setUserModalOpen(false);
    setUserData(getEmptyAddUser());
  };

  const getAllData = () => {
    userTableRef?.current?.getAllUsers();
  };

  const clickTab = (tabIndex: React.SetStateAction<number>) => {
    setSelectedTab(tabIndex);
  };

  return (
    <>
      <div className=" flex text-textColor  bg-customGray font-sans min-h-screen">
        <div className="flex flex-col flex-1 w-4/5  p-0">
          <div className="flex items-center justify-between bg-white px-4 py-2 shadow-sm border-b">
            {/* Left: icon and Breadcrumbs */}
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-2">
                <SettingsIcon />
                <span className="font-bold text-lg">Settings</span>
              </div>
              <div className="text-[13px] text-gray-500 space-x-2 hidden sm:flex">
                <span>Carriers</span>
                <span>•</span>
                <span>Loads Report</span>
                <span>•</span>
                <span
                  className="cursor-pointer text-gray-500 hover:text-greenBg"
                  onClick={() => setShowCalculator(true)}
                >
                  Calculator
                </span>

                <span>•</span>
                <span>View Asset Map</span>
                <span>•</span>
              </div>
            </div>
            <div className="px-4 py-1 items-center space-x-1">
              <button
                className="bg-customOrange hover:bg-greenBg text-white text-sm font-semibold px-4 py-1 rounded-md space-x-1 shadow-[1px_2px_2px_rgba(0,0,0,0.3)]"
                onClick={addEditModel}
              >
                Add User
              </button>
            </div>
          </div>

          <div className="min-h-screen bg-gray-100 px-4 py-2">
            <div className="bg-white w-full h-full rounded-xl">
              <div>
                <div>
                  <div className=" text-[13px]">
                    <div className="bg-white  px-2  mb-[2px]  flex flex-wrap space-x-2 lg:space-x-2 w-full rounded-2xl ">
                      <div className="relative flex py-2 gap-2  ">
                        <button
                          className={` px-2 py-1 text-sm  lg:px-4 lg:py-1  rounded-md font-medium shadow-sm 
                                                    ${selectedTab === 1
                              ? "bg-greenBg text-white"
                              : " bg-customGray hover:bg-greenBg hover:text-white"
                            }`}
                          onClick={() => {
                            clickTab(1);
                          }}
                        >
                          Company Profile
                        </button>
                        <button
                          className={` px-2 py-1 text-sm  lg:px-4 lg:py-1  rounded-md font-medium shadow-sm 
                                                    ${selectedTab === 2
                              ? "bg-greenBg text-white"
                              : " bg-customGray hover:bg-greenBg hover:text-white"
                            }`}
                          onClick={() => {
                            clickTab(2);
                          }}
                        >
                          Users
                        </button>
                        <button
                          className={` px-2 py-1 text-sm  lg:px-4 lg:py-1  rounded-md font-medium shadow-sm 
                                                    ${selectedTab === 3
                              ? "bg-greenBg text-white"
                              : " bg-customGray hover:bg-greenBg hover:text-white"
                            }`}
                          onClick={() => {
                            clickTab(3);
                          }}
                        >
                          Account Requests
                        </button>
                      </div>
                    </div>
                    {selectedTab === 1 && <CompanyForm />}
                    {selectedTab === 2 && (
                      <UsersTable
                        addEditModel={addEditModel}
                        ref={userTableRef}
                      />
                    )}

                    {selectedTab === 3 && (
                      <AcUserRequestTable
                        addEditModel={addEditModel}
                        ref={userTableRef}
                        getAllData={getAllData}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showCalculator && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-xl ">
              <Calculator onClose={() => setShowCalculator(false)} />
            </div>
          </div>
        )}
      </div>
      <AddUser
        isOpen={userModalOpen}
        closeModal={closeModal}
        getDataALLs={getAllData}
        openModal={userData}
      ></AddUser>
    </>
  );
};

export default CompanyProfile;
